import React from 'react'
import Menu from '../../components/Menu'
import Banner from '../../components/Banner'
import Footer from '../../components/Footer'

const Home = () => {
    return(
        <>
            <Menu />
            <Banner />
            <Footer />
        </>
    )
}

export default Home